import { BaseExamination } from '../../models';
import { fromServerIsoString } from '../../models/interop';
import { TranslateService } from '@ngx-translate/core';
import { NotificationType } from '@se/se.ui.html5';

export const getTooltipForSelectionHandler = (rowData: any) => {
    let time = !!rowData['examinationDate']
        ? ' - ' +
        new Date(rowData['examinationDate']).toLocaleDateString() +
        ' ' +
        new Date(rowData['examinationDate']).toLocaleTimeString()
        : '';
    const patient = rowData?.['patient'] && typeof rowData['patient'] === 'object' ? rowData['patient'] : {};
    return (patient['lastName'] ?? '') + ' ' + (patient['firstName'] ?? '') + time;
};

export const getButtonContentForSelectionHandler = (rowData: any) => {
    const patient = rowData['patient'];
    const lastInitial = patient.firstName ? patient.firstName[0].toLocaleUpperCase() : '';
    const firstInitial = patient.lastName ? patient.lastName[0].toLocaleUpperCase() : '';
    return `${firstInitial} ${lastInitial}`;
};

export const isSingleSelectionOfLocalPatient = (items: BaseExamination[]): boolean =>
    Boolean(items && items.length === 1 && items[0].patient && !items[0].patient.isLocalPatient);


export const separatePatientByCertification = (selectedItems: BaseExamination[]) => {
    const certificatedPatients = selectedItems.filter((ex) => !ex.patient.isLocalPatient);
    const notCertificatedPatients = selectedItems.filter((ex) => ex.patient.isLocalPatient);
    return { certificatedPatients, notCertificatedPatients };
};

export const checkPatientsDifference = (notCertificatedPatients: BaseExamination[], certificatedPatients: BaseExamination[]) =>
    notCertificatedPatients.some((item) => (
            item.patient.lastName !== certificatedPatients[0].patient.lastName ||
            item.patient.firstName !== certificatedPatients[0].patient.firstName ||
            item.patient.birthDate !== certificatedPatients[0].patient.birthDate ||
            item.patient.sex !== (certificatedPatients[0].patient.sex)
        ),
    );

export const prepareCertificatedPatientsMessage = (notCertificatedPatients: BaseExamination[]) =>
    notCertificatedPatients.map((item) => {
        const lastName = item.patient.lastName?.toUpperCase() || '';
        const firstName = item.patient.firstName?.toUpperCase() || '';
        const birthDate = fromServerIsoString(item.patient.birthDate).toDate().toLocaleDateString();
        return `${lastName} ${firstName} (${birthDate})`;
    }).join(', ');


export const createNotificationConfig = (certificatedPatientsMessage: string, certificatedPatients: BaseExamination[], translate: TranslateService) => {
    const lastName = certificatedPatients[0].patient.lastName?.toUpperCase() || '';
    const firstName = certificatedPatients[0].patient.firstName?.toUpperCase() || '';
    const birthDate = fromServerIsoString(certificatedPatients[0].patient.birthDate)
        .toDate()
        .toLocaleDateString();

    return {
        buttonYes: true,
        buttonNo: true,
        buttonCancel: false,
        buttonOk: false,
        title: translate.instant('Warning'),
        message: `${translate.instant('OnOpeningExamsDifferencesConfirm')} ${certificatedPatientsMessage} ${translate.instant('OnOpeningExamsDifferencesConfirm_1')} ${lastName} ${firstName} (${birthDate}). ${translate.instant('OnOpeningExamsDifferencesConfirm_2')}`,
        type: NotificationType.warning,
    };
};
